import { useEffect, useMemo, useState } from 'react';
import './hubSettings.css';

import CategoryIcons from '../../../../assets/categoryIcons/categoryIcons';
import VerticalBar from '../../../../components/verticalBar/verticalBar';
import SpacerBar from '../../../../components/spacerBar/spacerBar';
import DropDownArrow from '../../../../assets/icons/dropDownArrow/dropDownArrow';

export default function HubSettings({expenses, userCategories}) {
    
    useEffect(() => {const recentExpenses = expenses; setHubList(recentExpenses);}, [expenses]);

    const [selectedItem, setSelectedItem] = useState(false);
    const [hubList, setHubList] = useState([{expense_name: 'loading...'}]);
    const [switchIndex, setSwitchIndex] = useState(false);
    const [formData, setFormData] = useState({});
    const [catChange, setCatChange] = useState(false);
    const [newCat, setNewCat] = useState();

    const hubSwitchClick = () => {
        setSwitchIndex(prev => !prev);
        setSelectedItem(false);

        const currentSwitch = !switchIndex;
        const recentExpenses = expenses.reverse();

        currentSwitch ? 
            setHubList(userCategories)
            :
            setHubList(recentExpenses)
        ;
        
    };

    const listIndex = (index, item) => {
        setSelectedItem(item);
        setCatChange(false);

        switchIndex ? 
        setFormData({
            type: 'category',
            expense_category_id: item.expense_category_id,
            expense_name: item.expense_name,
            expense_description: item.expense_description,
            expense_svg_icon: item.expense_svg_icon,
            expense_svg_color: item.expense_svg_color
        })
        :
        setFormData({
            type: 'expense',
            expense_id: item.expense_id,
            expense_name: item.expense_name,
            expense_cat_id: item.expense_category_id,
            expense_amount: item.expense_amount,
            expense_date: item.expense_date,
            expense_details: item.expense_details
        })
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));
    }

    const handleCategoryChange = (e) => {
    setFormData((prev) => ({
        ...prev,
        expense_cat_id: Number(e.target.value)
    }));
    
    const matchedCategory = userCategories.find(
        (cat) => cat.expense_category_id === Number(e.target.value)
    );
    
    setNewCat(matchedCategory);
    setCatChange(true);
};

    const handleSave = async (e) => {
    e.preventDefault();
    console.log(formData);

    if (formData.type === 'expense') {
        try {
            const res = await fetch('/fastapi/api/put_expense', {
                method: 'PUT',
                credentials: 'include', 
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    expense_id: formData.expense_id,
                    expense_cat_id: formData.expense_cat_id,
                    expense_amount: formData.expense_amount,
                    expense_date: formData.expense_date,
                    expense_details: formData.expense_details,
                    expense_image: formData.expense_image
                })
            });

            if (!res.ok) {
                throw new Error('Failed to update expense');
            }

            const result = await res.json();
            console.log('Success:', result);
            alert('Expense updated successfully!');
            window.location.reload();
        } 
        catch (error) {
            console.error('Error updating expense:', error);
            alert('Error updating expense. Please try again.');
        }
    }

    if (formData.type === 'category') {
        try {
            const res = await fetch('/fastapi/api/put_category', {
                method: 'PUT',
                credentials: 'include', 
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    expense_id: formData.expense_category_id, // Matches backend model schema
                    expense_name: formData.expense_name,
                    expense_description: formData.expense_description,
                    expense_svg_icon: formData.expense_svg_icon,
                    expense_svg_color: formData.expense_svg_color
                })
            });

            if (!res.ok) {
                throw new Error('Failed to update category');
            }

            const result = await res.json();
            console.log('Success:', result);
            alert('Category updated successfully!');
            window.location.reload();
        } 
        catch (error) {
            console.error('Error updating category:', error);
            alert('Error updating category. Please try again.');
        }
    }
};

    const handleDelete = async (e) => {
        e.preventDefault();

        if (formData.type === 'expense') {

        try {
            const res = await fetch('/fastapi/api/delete_expense', {
                method: 'DELETE',
                credentials: 'include', 
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    expense_id: formData.expense_id
                })
            })

            if (!res.ok) {
                throw new Error('Failed to delete expense');
            }

            const result = await res.json();
            console.log('Success:', result);
            alert('Expense Deleted successfully!');
            window.location.reload();
        
        }
        catch (error) {
            console.error('Error deleteing expense:', error);
            alert('Error deleteing expense. Please try again.');
        }
        }

        if (formData.type === 'category') {

        try {
            const res = await fetch('/fastapi/api/delete_category', {
                method: 'DELETE',
                credentials: 'include', 
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    expense_id: formData.expense_category_id
                })
            })

            if (!res.ok) {
                throw new Error('Failed to delete category');
            }

            const result = await res.json();
            console.log('Success:', result);
            alert('Category deleted successfully!');
            window.location.reload();
        
        }
        catch (error) {
            console.error('Error deleteing category:', error);
            alert('Error deleteing category. Please try again.');
        }
        }

    }

    return (
        <div className="hub-settings">
            <p>Edit or Delete:</p>
            <div className="hub-settings-container">
                <div className="hub-settings-content card">
                    <div className="hub-switch">
                        <div className={switchIndex ? 'hub-switch-active switch-right': 'hub-switch-active switch-left'}></div>
                        <button className={switchIndex ? 'hub-switch-button' : 'hub-switch-button hub-active' } onClick={hubSwitchClick}>Expenses</button>
                        <button className={switchIndex ? 'hub-switch-button hub-active' : 'hub-switch-button' } onClick={hubSwitchClick}>Categories</button>
                    </div>
                    <div className="hub-list scroll-container">
                        {
                                    hubList?.map((item, index) => {
                                        return(
                                        <div key={index}>
                                            <div key={index} className={ 'hub-expenses-list-item-container list-click' } onClick={() => listIndex(index, item)}>
                                                {/*<BulletPoint/>*/}
                                                <CategoryIcons indexIcon={item.expense_svg_icon} expenseColor={item.expense_svg_color} className=''/>
                                                <p>{switchIndex ? item.expense_name : item.expense_name}</p>
                                                <VerticalBar height='4vh'/>
                                                <p><strong>{switchIndex ? item.expense_category_id : `$${item.expense_amount}`}</strong></p>
                                                <VerticalBar height='4vh'/>
                                                <p className="switch-width">{switchIndex ? item.expense_description :new Date(item.expense_date).toLocaleDateString()}</p>
                                                
                                            </div>
                                            <SpacerBar width='95%' center='auto'/>
                                        </div>
                                    )})}
                    </div>
                </div>
                <div className="hub-settings-control card">
                    {selectedItem ? 

                    (switchIndex ? 
                        
                        <div>
                            <form className="hub-expense-form">

                                <div className="hub-expense-header">
                                    <p>Category: id <strong><p>{formData?.expense_category_id}</p></strong></p>
                                </div>

                                <label>Category Name:</label>
                                <input 
                                    className="input-name"
                                    name="expense_name"
                                    value={formData.expense_name} 
                                    type="text"
                                    onChange={handleChange}
                                />

                                <label>Category Dexcription:</label>
                                <textarea 
                                    style={{height: '10rem', marginTop: '0'}}
                                    className="expense-notes" 
                                    name="expense_description"
                                    value={formData?.expense_description}
                                    onChange={handleChange}
                                />

                                <label>Category Icon: <strong> 1 - 32</strong></label>
                                <input 
                                    className="input-name"
                                    name="expense_svg_icon"
                                    value={formData?.expense_svg_icon} 
                                    type="text"
                                    onChange={handleChange}
                                />

                                <label>Category Hex Color:</label>
                                <input 
                                    className="input-name"
                                    name="expense_svg_color"
                                    value={formData?.expense_svg_color} 
                                    type="text"
                                    onChange={handleChange}
                                />

                                <div className="hub-button-container">
                                    <button className="button" onClick={handleSave}>Save</button>
                                    <button className="button" onClick={handleDelete}>Delete</button>
                                </div>

                            </form>
                        </div>

                    : 
                    
                        <div>
                            <form className="hub-expense-form">
                                
                                <div className="hub-expense-header">
                                    <p>Expense name: {formData.expense_name}</p>
                                    <p>ID: <strong>{formData.expense_id}</strong></p>
                                    {catChange ? <CategoryIcons indexIcon={newCat?.expense_svg_icon} expenseColor={newCat?.expense_svg_color} className=''/> : <CategoryIcons indexIcon={selectedItem.expense_svg_icon} expenseColor={selectedItem.expense_svg_color} className=''/>}
                                </div>

                                <label>Amount:</label>
                                <input 
                                    className="input-name"
                                    name="expense_amount"
                                    value={formData.expense_amount} 
                                    type="number" 
                                    step="0.01" 
                                    onChange={handleChange}
                                />

                                <label>Date:</label>
                                <input 
                                    className="input-date" 
                                    placeholder='Date (YYYY-MM-DD)'
                                    type="date"
                                    name="expense_date"
                                    value={formData.expense_date}
                                    onChange={handleChange}
                                    required
                                    />

                                <label>Category:</label>
                                <div className="expense-category-selector">
                                    <div className="select-container">
                                        <select 
                                            name="expense_cat_id" 
                                            id="categories" 
                                            onChange={handleCategoryChange} 
                                            value={formData?.expense_cat_id !== undefined ? String(formData.expense_cat_id) : ''}
                                        >
                                            <option value="" disabled>Select a category</option>
                                            {userCategories?.map((cat, index) => (
                                                <option 
                                                    key={index} 
                                                    value={String(cat?.expense_category_id)} 
                                                >
                                                    {cat?.expense_name}
                                                </option>
                                            ))}
                                        </select>
                                        <DropDownArrow/>
                                    </div>
                                </div>

                                <div className="hub-button-container">
                                    <button className="button" onClick={handleSave}>Save</button>
                                    <button className="button" onClick={handleDelete}>Delete</button>
                                </div>

                            </form>
                        </div>
                
                    )

                    : 
                    
                    <div>
                        <p>Select and Item to edit or delete</p>
                    </div>
                    
                    }

                </div>
            </div>
        </div>
    )
}



                    /* <div>
                        <div>
                            <CategoryIcons indexIcon={selectedItem.expense_svg_icon} expenseColor={selectedItem.expense_svg_color} className=''/>
                            <p>{selectedItem.expense_name}</p>
                            <strong>{selectedItem.expense_amount || selectedItem.expense_category_id}</strong>
                            <p>{selectedItem.expense_date || selectedItem.expense_description}</p>
                        </div>
                        <div>Button</div>
                    </div>*/